export default "__VITE_ASSET__DFPVAZ$R__"